export default "__VITE_ASSET__7f0bf8d6__"